import ReceivedInvoiceForm from "../components/received-invoice/ReceivedInvoiceForm";

const ReceivedInvoicePage = () => {
  return <ReceivedInvoiceForm />;
};

export default ReceivedInvoicePage;
